<template>
  <div>
    <div v-if="$store.getters.nivel == 3">
      <p class="pa-md-6">{{ $store.getters.nome }} seja bem vindo(a) ao SIGU, antes de continuar selecione a Odonto que deseja mexer.</p>
    </div>
    <div v-if="$store.getters.nivel == 1 || $store.getters.nivel == 5">
      <v-container>
        <v-row class="mb-6">
          <v-col class="px-md-3 py-md-2 mx-lg-auto" cols="12">
            <v-card class="px-md-3 py-md-2">
              <v-card-title class="headline">
                <v-row align="center" justify="start">
                  Senha para dispensa setor:
                  <div v-if="visualizarSenhaDispensa" class="px-2">
                    <b>{{ senhaDispensaAtual }}</b>
                  </div>
                  <div v-if="!visualizarSenhaDispensa" class="px-2">
                    <v-skeleton-loader light tile boilerplate class="rounded" type="chip"></v-skeleton-loader>
                  </div>

                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn light icon v-bind="attrs" v-on="on" @click="visualizarSenhaDispensa = !visualizarSenhaDispensa">
                        <v-icon>mdi-eye</v-icon>
                      </v-btn>
                    </template>
                    <span>Visualizar Senha</span>
                  </v-tooltip>
                </v-row>
              </v-card-title>
            </v-card>
          </v-col>
        </v-row>

        <v-row class="mb-6" no-gutters>
          <v-col cols="3" class="pa-md-1">
            <v-card color="#00c0ef" dark>
              <v-card-title class="headline">{{ cardData.enderecosCadastrados }}</v-card-title>
              <v-card-actions>Unidades</v-card-actions>
            </v-card>
          </v-col>

          <v-col cols="3" class="pa-md-1">
            <v-card color="#00a65a" dark>
              <v-card-title class="headline">{{ cardData.usuariosCadastrados }}</v-card-title>
              <v-card-actions>Usuários</v-card-actions>
            </v-card>
          </v-col>

          <v-col cols="3" class="pa-md-1">
            <v-card color="#d8c628" dark>
              <v-card-title class="headline">{{ cardData.itensCadastrados }}</v-card-title>
              <v-card-actions>Produtos</v-card-actions>
            </v-card>
          </v-col>

          <v-col cols="3" class="pa-md-1">
            <v-card color="#dd4b39" dark>
              <v-card-title class="headline">{{ cardData.dispensasCadastradas }}</v-card-title>
              <v-card-actions>Dispensas</v-card-actions>
            </v-card>
          </v-col>
        </v-row>

        <v-row class="mb-6">
          <v-col class="pa-md-3 mx-lg-auto" cols="12">
            <v-card class="pa-md-3">
              <v-card-title class="headline"
                >Média de Consumo ao Ano | {{ anoSelecionado }}
                <v-menu offset-x transition="scale-transition">
                  <template v-slot:activator="{ on: menu, attrs }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on: tooltip }">
                        <v-btn light icon v-bind="attrs" v-on="{ ...tooltip, ...menu }">
                          <v-icon>mdi-autorenew</v-icon>
                        </v-btn>
                      </template>
                      <span>Alterar o Ano</span>
                    </v-tooltip>
                  </template>
                  <v-list>
                    <v-list-item v-for="(ano, i) in listaAnos" :key="i" @click="alterarAno(ano.value)">
                      <v-list-item-title>{{ ano.text }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-card-title>
              <v-card-text>
                <v-autocomplete label="Selecione uma Unidade para ver suas Dispensas" :items="listaUnidades" v-model="unidadeSelecionada" clearable></v-autocomplete>

                <v-expand-transition>
                  <Bar v-if="mostraGraficoDispensa" height="150px" :options="optionsDispensa" :chartData="dispensasPorUnidade"></Bar>
                </v-expand-transition>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col class="pa-md-3 mx-lg-auto" cols="12" max-height="1000px">
            <v-card class="pa-md-3">
              <v-card-title class="headline">Produtos por Unidade</v-card-title>
              <v-card-text>
                <Bar height="250px" :options="options" :chartData="itensPorUnidade"></Bar>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>

<script>
import Bar from "@/components/Charts/Bar";
import axios from "@/plugins/axios";
import store from "@/store/index";
import colorPattern from "@/utils/colorPattern.js";

export default {
  components: {
    Bar,
  },

  sockets: {
    reciveInsertUnidade: function(data) {
      if (data) {
        if (data.descricaoTela == "dispensaSetor") {
          this.configuracaoSistema();
        }
      }
    },
  },

  data() {
    return {
      config: {
        headers: {
          "Content-Type": "application/json",
          "x-auth-token": store.state.token,
        },
      },

      options: {
        legend: {
          display: false,
          position: "bottom",
          align: "start",
        },
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
            },
          ],
        },
        hover: { mode: null },
      },

      optionsDispensa: {
        legend: {
          display: true,
          position: "bottom",
          align: "center",
        },
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
            },
          ],
        },
        hover: { mode: null },
      },
      itensPorUnidade: {
        datasets: [],
        labels: [],
      },

      dispensasPorUnidade: {
        datasets: [],
        labels: [],
      },

      cardData: {
        enderecosCadastrados: "",
        usuariosCadastrados: "",
        itensCadastrados: "",
        dispensasCadastradas: "",
      },

      listaUnidades: [],
      unidadeSelecionada: null,

      senhaDispensaAtual: null,
      visualizarSenhaDispensa: false,

      anoSelecionado: new Date().getFullYear(),
      listaAnos: [],

      mostraGraficoDispensa: false,
    };
  },

  created() {
    this.configuracaoSistema();
    this.gerarListaDeAnos();
    this._getData();
  },

  watch: {
    unidadeSelecionada() {
      if (this.unidadeSelecionada) {
        this.mostraGraficoDispensa = false;
        this.dispensasFeitasPelaUnidade(this.unidadeSelecionada, this.anoSelecionado);
      } else {
        this.mostraGraficoDispensa = false;
      }
    },
  },

  methods: {
    async configuracaoSistema() {
      try {
        const responseData = await axios.get("/configuracao", this.config);
        this.senhaDispensaAtual = responseData.data.descricaoSenhaDispensa;
      } catch (error) {
        console.log(error);
      }
    },

    async _getData() {
      try {
        const responseData = await axios.get("/dashboard", this.config);

        this.cardData.enderecosCadastrados = responseData.data.quantidadeEnderecos;
        this.cardData.usuariosCadastrados = responseData.data.quantidadeFuncionarios;
        this.cardData.itensCadastrados = responseData.data.quantidadeItens;
        this.cardData.dispensasCadastradas = responseData.data.quantidadeDispensas;

        const responseDataGraficoItens = await axios.get("/dashboardGraficoItens", this.config);
        this.itensPorUnidade = responseDataGraficoItens.data;

        //Cores do gráfico "Itens por Unidade"
        this.itensPorUnidade.datasets.map((itemSelecionado) => {
          itemSelecionado.backgroundColor = colorPattern[Math.ceil(Math.random() * 44)];
        });

        const responseEnderecos = await axios.get("enderecoOrdemServico", this.config);

        this.listaUnidades = responseEnderecos.data.map((unidadeSelecionada) => {
          return {
            value: unidadeSelecionada.numeroEnderecoOrdemServico,
            text: unidadeSelecionada.nomeEndereco,
          };
        });
      } catch (error) {
        console.log(error);
      }
    },

    async dispensasFeitasPelaUnidade(numeroEndereco, anoSelecionado) {
      try {
        const responseDataGraficoDispensa = await axios.put("/dashboardGraficoDispensa", { numeroEndereco: numeroEndereco, anoSelecionado: anoSelecionado }, this.config);
        this.dispensasPorUnidade = responseDataGraficoDispensa.data;

        this.mostraGraficoDispensa = true;
      } catch (error) {
        console.log(error);
      }
    },

    alterarAno(anoSelecionado) {
      this.anoSelecionado = anoSelecionado;

      if (this.unidadeSelecionada) {
        this.mostraGraficoDispensa = false;
        this.dispensasFeitasPelaUnidade(this.unidadeSelecionada, this.anoSelecionado);
      } else {
        this.mostraGraficoDispensa = false;
      }
    },

    gerarListaDeAnos() {
      const anoAtual = new Date().getFullYear();
      for (let i = 2021; i <= anoAtual; i++) {
        this.listaAnos.push({
          value: i,
          text: i,
        });
      }
    },
  },
};
</script>

<style></style>
